import ExcelJS from 'exceljs';
import * as XLSX from 'xlsx';
import { NotificationSound } from './CommonNotification';
import { CommonApiData, virtualPath } from './EnvConfig';
import { pathName } from './CustomHooks';

export const DownloadFileAtURL = (File) => {
    let FileName = `ImportFormat/${File}`
    const fileName = FileName.split('/').pop()
    const aTag = document.createElement('a');
    aTag.href = FileName
    aTag.setAttribute('download', fileName)
    document.body.appendChild(aTag);
    aTag.click();
    aTag.remove();
}

export const ERRORDATALIST = async (Status, FileName) => {
    try {
        let enableAlternateColor = false, enableHeaderColor = true
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet 1', {
            views: [{ state: 'frozen', ySplit: 1 }],
        });

        // Prepare the data for the worksheet
        const dataRows = Status.ErrorData.map(record =>
            Object.values(record)
        );

        // Extract headers
        const headers = Object.keys(Status.ErrorData[0]);

        // Add headers and data to the worksheet
        worksheet.addRow(headers);
        worksheet.addRows(dataRows);

        // Set header row style (bold and background color)
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true };
        if (enableHeaderColor) {
            headerRow.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'AAAAAA' },
            };
        }
        if (enableAlternateColor) {
            worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
                if (rowNumber > 1 && rowNumber % 2 === 0) {
                    row.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'DDDDDD' },
                    };
                }
            });
        }

        // Set column widths to fit content
        worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const length = cell.value ? String(cell.value).length : 0;
                maxLength = Math.max(maxLength, length);
            });
            column.width = maxLength < 12 ? 12 : maxLength; // Set a minimum width to avoid extremely narrow columns
        });
        // Generate and download the Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const dataBlob = new Blob([buffer], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(dataBlob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${FileName}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (err) {
        console.error('Error creating Excel:', err);
    }
};

export const BulkClearData = (setName) => {
    let a = document.querySelectorAll('.bulk-upload');
    if (a.length > 0) {
        a[0].childNodes[2].innerHTML = '<span class="sc-fqkvVR kFhUBM"><span>Upload</span> or drop a file right here</span><span title="types: xlsx" class="file-types">.xlsx</span>';
    }
    setName('')

}

export const convertToJson = (csv) => {
    var lines = csv.split("\n");

    var result = [];

    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length; i++) {
        var obj = {};
        var currentline = lines[i].split(",");
        for (var j = 0; j < headers.length; j++) {
            //if (headers[j] === 'Active') {
            //    obj[headers[j]] = Boolean(parseInt(currentline[j]) === 0 || currentline[j].toLowerCase() === ('No').toLowerCase() ? Boolean(false) : Boolean(currentline[j]));
            //}
            //else {
            //    obj[headers[j]] = currentline[j];
            //}
            obj[headers[j]] = currentline[j].toLowerCase() === 'true'.toLowerCase() ? true : currentline[j].toLowerCase() === 'false'.toLowerCase() ? false : currentline[j];

        }
        result.push(obj);
    }
    return JSON.stringify(result); //JSON
}

export const readFile = async (e) => {
    const file = e;
    let FileName = e.name;
    const data = await file.arrayBuffer(file);
    const excelFile = XLSX.read(data);
    const excelSheet = excelFile.Sheets[excelFile.SheetNames[0]];
    const exceljson = XLSX.utils.sheet_to_json(excelSheet, {
        defval: "", // Treat undefined cells as empty strings
        raw: false, // Keep raw data, such as format strings, dates, etc.
        header: 0 // Use the first row as keys
    });
    // Function to convert text to boolean
    const textToBoolean = (text) => {
        const lowerText = text.toLowerCase();
        if (lowerText === "true") {
            return true;
        } else if (lowerText === "false") {
            return false;
        }
        // Handle other cases if needed
        return null; // Or throw an error, or return a default value
    };
    // Convert text values to booleans in the exceljson object
    for (let i = 0; i < exceljson.length; i++) {
        const row = exceljson[i];
        for (const key in row) {
            if (row.hasOwnProperty(key)) {
                const value = row[key];
                if (typeof value === "string") {
                    const booleanValue = textToBoolean(value);
                    if (booleanValue !== null) {
                        row[key] = booleanValue;
                    }
                }
            }
        }
    }

    return { exceljson, FileName };
};

export const readFile2 = async (e) => {
    const file = e;
    let FileName = e.name;
    const data = await file.arrayBuffer();
    const excelFile = XLSX.read(data, { type: 'array' });
    const textToBoolean = (text) => {
        const lowerText = text.toLowerCase();
        if (lowerText === "true") {
            return true;
        } else if (lowerText === "false") {
            return false;
        }
        return text;
    };

    // Process Sheet1
    const sheet1 = excelFile.Sheets[excelFile.SheetNames[0]];
    const dataSheet1 = XLSX.utils.sheet_to_json(sheet1, {
        defval: "",
        raw: false,
        header: 1
    });
    const headers1 = dataSheet1[0];
    const tempRows1 = dataSheet1.slice(1);
    if (tempRows1.length > 5000) {
        throw new Error("Each sheet must contain less than 5000 rows.");
    }
    const rows1 = dataSheet1.slice(1).map(row => {
        const rowObj = {};
        headers1.forEach((header, index) => {
            rowObj[header] = textToBoolean(row[index]);
        });
        return rowObj;
    });

    // Process Sheet2
    const sheet2 = excelFile.Sheets[excelFile.SheetNames[1]];
    const dataSheet2 = XLSX.utils.sheet_to_json(sheet2, {
        defval: "",
        raw: false,
        header: 1
    });
    const headers2 = dataSheet2[0];
    const tempRow2 = dataSheet2.slice(1);
    if (tempRow2.length > 10000) {
        throw new Error("Each sheet must contain less than 5000 rows.");
    }
    const rows2 = dataSheet2.slice(1).map(row => {
        const rowObj = {};
        headers2.forEach((header, index) => {
            rowObj[header] = textToBoolean(row[index]);
        });
        return rowObj;
    });

    return { sheet1: rows1, sheet2: rows2, FileName };
};

export const HandleBulkInsertData = async (url, Records, data, refreshData, onProgressUpdate, loopError = false) => {
    let SuccessCount = 0;
    let ErrorData = [];
    let ErrorCount = 0;
    let Count = Records.length;

    if (Count === 0) {
        alert('No Record Found!');
        return { SuccessCount, ErrorCount, ErrorData };
    }

    for (let i = 0; i < Records.length; i++) {
        let response = {
            ...data,
            "authToken": pathName ? CommonApiData().UserAuthToken : CommonApiData().AuthToken,
            "loginToken": CommonApiData().LoginToken,
            "loginUserCode": pathName ? CommonApiData().UserCode : CommonApiData().loginUserCode,
            ...Records[i]
        };
        try {
            let resp = await fetch(`${virtualPath + url}`, {
                method: 'POST',
                body: JSON.stringify(response),
                headers: {
                    "Content-Type": "application/json"
                },
            });

            if (!resp.ok) {
                throw new Error(`HTTP error! status: ${resp.status}`);
            }

            let res = await resp.json();
            if (res.status === "SUCCESS" || res.Status === "SUCCESS") {
                SuccessCount += 1;
            } else if (res.status === 'ERROR' || res.Status === "ERROR") {
                if (loopError && res.subItemsStatus.length>0) {
                    res.subItemsStatus.forEach(item => {
                        ErrorData.push(item);
                    });
                    ErrorCount += 1;
                } else {
                ErrorData.push({ ...Records[i], ERROR: res.message || res.Message });
                    ErrorCount += 1;
                }
            }

            Count -= 1;

            if (onProgressUpdate) {
                onProgressUpdate({
                    total: Records.length,
                    processed: Records.length - Count,
                    successCount: SuccessCount,
                    errorCount: ErrorCount,
                    errorData: ErrorData
                });
            }
        } catch (error) {
            // Log the error for debugging
            console.error(`Error processing record ${i}:`, error);
            ErrorData.push({ ...Records[i], ERROR: error.message });
            ErrorCount += 1;
            Count -= 1;

            if (onProgressUpdate) {
                onProgressUpdate({
                    total: Records.length,
                    processed: Records.length - Count,
                    successCount: SuccessCount,
                    errorCount: ErrorCount,
                    errorData: ErrorData
                });
            }
        }
    }
    if (refreshData) { refreshData(); }

    return { SuccessCount, ErrorCount, ErrorData };
};



export const HandleBulkInsertDataJSON = async (url, Records, common, refreshData) => {
    let SuccessCount = 0
    let ErrorData = []
    let ErrorCount = 0
    let Count = Records.length
    if (Records.length !== 0) {
        let response = ({ ...common, data: Records })
        await fetch(`${virtualPath + url}`, {
            method: 'POST',
            body: JSON.stringify(response),
            headers: {
                "Content-Type": "application/json"
            },
            // eslint-disable-next-line no-loop-func
        }).then(async (resp) => {
            let res = await resp.json();
            Count = Count - 1
            if (res.status === "SUCCESS") {
                SuccessCount = SuccessCount + 1
            } else if (res.status === 'ERROR') {
                ErrorData.push({ ERROR: res.message })
                ErrorCount = ErrorCount + 1
            }
        })
    } else {
        alert('No Record Found !')
    }
    refreshData()
    return { SuccessCount, ErrorCount, ErrorData }
}
export const handleDownloadExcelUpdateBulk = async (handleApiUrl, requestData, FileName, enableAlternateColor = false, enableHeaderColor = true, enableFilters = false) => {
    const apiUrl = handleApiUrl;
    const requestBody = {
        ...requestData,
        "authToken": pathName ? CommonApiData().UserAuthToken : CommonApiData().AuthToken,
        "loginToken": CommonApiData().LoginToken,
        "loginUserCode": CommonApiData().UserCode,
        "Source": 'Web',
        Type: 'I',
        PageIndex: '1'
    };;
    const requestHeaders = {
        'Content-Type': 'application/json',
    };
    try {
        const response = await fetch(`${virtualPath + apiUrl}`, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: requestHeaders,
        });
        const res = await response.json();
        if (res.Status === "SUCCESS") {
            if (res && res?.Data && res?.Data.length > 0) {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet 1', {
                    views: [{ state: 'frozen', ySplit: 1 }],
                });

                // Example: Set header row to bold and background color
                const headerRow = worksheet && worksheet?.addRow(res?.HeadersKey?.length > 0
                    ? res.HeadersKey.filter((key) => {
                        return res?.HideColumns?.length > 0 ? !res?.HideColumns?.includes(key) : key
                    })
                    : Array.from(
                        new Set(
                            res?.Data?.flatMap((data) => Object.keys(data))
                                .filter((columnName) => !res?.HideColumns?.includes(columnName))
                        )
                    ));
                const headerKey = (res?.HeadersKey?.length > 0 && res?.HeadersValue?.length > 0)
                    ? res.HeadersValue.filter((key) => {
                        return res?.HideColumns?.length > 0 ? !res?.HideColumns?.includes(key) : key
                    })
                    : Array.from(
                        new Set(
                            res.Data?.flatMap((data) => Object.keys(data))
                                .filter((columnName) => !res?.HideColumns?.includes(columnName))
                        )
                    );
                headerRow.font = { bold: true };
                if (enableHeaderColor) {
                    headerRow.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'AAAAAA' },
                    };
                };
                // Example: Enable filters
                if (enableFilters) {
                    worksheet.autoFilter = {
                        from: { row: 1, column: 1 },
                        to: { row: 1, column: headerKey.length },
                    };
                };

                // Example: Set alternate row background color
                for (let i = 2; i <= res?.Data?.length + 1; i++) {
                    const row = worksheet.getRow(i);

                    if (enableAlternateColor && i % 2 === 0) {
                        row.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'DDDDDD' },
                        };
                    };

                    row.values = res?.HeadersValue?.length > 0 ?
                        res.HeadersValue?.map((key) => res.Data[i - 2][key])
                        : headerKey?.map((key) => res.Data[i - 2][key]);
                }



                // Set column widths to fit content
                worksheet?.columns?.forEach((column) => {
                    let maxLength = 0;
                    column.eachCell({ includeEmpty: true }, (cell) => {
                        const length = cell.value ? String(cell.value).length : 0;
                        maxLength = Math.max(maxLength, length);
                    });
                    column.width = maxLength < 12 ? 12 : maxLength; // Set a minimum width to avoid extremely narrow columns
                });

                //  //Auto-fit column width
                //worksheet.columns.forEach((column, index) => {
                //    let maxContentLength = column.header ? column.header.length : 0;

                //    for (let i = 2; i <= res.Data.length + 1; i++) {
                //        const content = res.Data[i - 2][res.HeadersValue[index]];
                //        if (content) {
                //            maxContentLength = Math.max(maxContentLength, content.toString().length);
                //        }
                //    }

                //    column.width = maxContentLength < 12 ? 12 : maxContentLength + 2;
                //});

                const buffer = await workbook.xlsx.writeBuffer();
                const data = new Blob([buffer], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${FileName}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                NotificationSound('ERROR', res.Message)
            }

        } else if (res.Status === 'ERROR') {
            NotificationSound(res.Status, res.Message, res.focus);
        }
        else if (res.Status === 'UNAUTHORIZED') {
            NotificationSound(res.Status, res.Message, res.focus);
        }
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus,);
        }
    } catch (err) {
        NotificationSound('ERROR', err.Message)
    }
};
export const handleDownloadExcel = async (handleApiUrl, requestData, FileName, enableAlternateColor = false, enableHeaderColor = true, enableFilters = false) => {
    const apiUrl = handleApiUrl;
    const requestBody = {
        ...requestData,
        "authToken": pathName ? CommonApiData().UserAuthToken : CommonApiData().AuthToken,
        "loginToken": CommonApiData().LoginToken,
        "loginUserCode": CommonApiData().UserCode,
        "Source": 'Web',
        Type: 'E',
        PageIndex: '1'
    };;
    const requestHeaders = {
        'Content-Type': 'application/json',
    };
    try {
        const response = await fetch(`${virtualPath + apiUrl}`, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: requestHeaders,
        });
        const res = await response.json();
        if (res.Status === "SUCCESS") {
            if (res && res?.Data && res?.Data.length > 0) {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet 1', {
                    views: [{ state: 'frozen', ySplit: 1 }],
                });

                // Example: Set header row to bold and background color
                const headerRow = worksheet && worksheet?.addRow(res?.HeadersKey?.length > 0
                    ? res.HeadersKey.filter((key) => {
                        return res?.HideColumns?.length > 0 ? !res?.HideColumns?.includes(key) : key
                    })
                    : Array.from(
                        new Set(
                            res?.Data?.flatMap((data) => Object.keys(data))
                                .filter((columnName) => !res?.HideColumns?.includes(columnName))
                        )
                    ));
                const headerKey = (res?.HeadersKey?.length > 0 && res?.HeadersValue?.length > 0)
                    ? res.HeadersValue.filter((key) => {
                        return res?.HideColumns?.length > 0 ? !res?.HideColumns?.includes(key) : key
                    })
                    : Array.from(
                        new Set(
                            res.Data?.flatMap((data) => Object.keys(data))
                                .filter((columnName) => !res?.HideColumns?.includes(columnName))
                        )
                    );
                headerRow.font = { bold: true };
                if (enableHeaderColor) {
                    headerRow.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'AAAAAA' },
                    };
                };
                // Example: Enable filters
                if (enableFilters) {
                    worksheet.autoFilter = {
                        from: { row: 1, column: 1 },
                        to: { row: 1, column: headerKey.length },
                    };
                };

                // Example: Set alternate row background color
                for (let i = 2; i <= res?.Data?.length + 1; i++) {
                    const row = worksheet.getRow(i);

                    if (enableAlternateColor && i % 2 === 0) {
                        row.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'DDDDDD' },
                        };
                    };

                    row.values = res?.HeadersValue?.length > 0 ?
                        res.HeadersValue?.map((key) => res.Data[i - 2][key])
                        : headerKey?.map((key) => res.Data[i - 2][key]);
                }



                // Set column widths to fit content
                worksheet?.columns?.forEach((column) => {
                    let maxLength = 0;
                    column.eachCell({ includeEmpty: true }, (cell) => {
                        const length = cell.value ? String(cell.value).length : 0;
                        maxLength = Math.max(maxLength, length);
                    });
                    column.width = maxLength < 12 ? 12 : maxLength; // Set a minimum width to avoid extremely narrow columns
                });

                //  //Auto-fit column width
                //worksheet.columns.forEach((column, index) => {
                //    let maxContentLength = column.header ? column.header.length : 0;

                //    for (let i = 2; i <= res.Data.length + 1; i++) {
                //        const content = res.Data[i - 2][res.HeadersValue[index]];
                //        if (content) {
                //            maxContentLength = Math.max(maxContentLength, content.toString().length);
                //        }
                //    }

                //    column.width = maxContentLength < 12 ? 12 : maxContentLength + 2;
                //});

                const buffer = await workbook.xlsx.writeBuffer();
                const data = new Blob([buffer], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${FileName}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                NotificationSound('ERROR', res.Message)
            }

        } else if (res.Status === 'ERROR') {
            NotificationSound(res.Status, res.Message, res.focus);
        }
        else if (res.Status === 'UNAUTHORIZED') {
            NotificationSound(res.Status, res.Message, res.focus);
        }
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus,);
        }
    } catch (err) {
        NotificationSound('ERROR', err.Message)
    }
};

export const handleDownloadMultipleExcel = async (
    handleApiUrl,
    requestData,
    FileName,
    enableAlternateColor = false,
    enableHeaderColor = true,
    enableFilters = false,
) => {
    const apiUrl = handleApiUrl;
    const requestBody = requestData;
    const requestHeaders = {
        'Content-Type': 'application/json',
    };
    try {
        const response = await fetch(`${virtualPath + apiUrl}`, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: requestHeaders,
        });
        const res = await response.json();
        if (res[0].Status === 'SUCCESS') {
            const workbook = new ExcelJS.Workbook();
            for (let sheetData of res) {
                const sheetName = Object.keys(sheetData.Data[0])[0]; // Get the sheet name
                const sheetRows = sheetData.Data[0][sheetName]; // Get the rows for the sheet

                const worksheet = workbook.addWorksheet(sheetName, {
                    views: [{ state: 'frozen', ySplit: 1 }],
                });

                const headers = Object.keys(sheetRows[0]);
                const headerRow = worksheet.addRow(headers);
                headerRow.font = { bold: true };

                if (enableHeaderColor) {
                    headerRow.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'AAAAAA' },
                    };
                }

                for (let rowData of sheetRows) {
                    const row = worksheet.addRow(Object.values(rowData));
                    if (enableAlternateColor && worksheet.lastRow.number % 2 === 0) {
                        row.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'DDDDDD' },
                        };
                    }
                }

                if (enableFilters) {
                    worksheet.autoFilter = {
                        from: { row: 1, column: 1 },
                        to: { row: 1, column: headers.length },
                    };
                }

                worksheet.columns.forEach(column => {
                    let maxLength = 0;
                    column.eachCell({ includeEmpty: true }, cell => {
                        const length = cell.value ? String(cell.value).length : 0;
                        maxLength = Math.max(maxLength, length);
                    });
                    column.width = maxLength < 12 ? 12 : maxLength;
                });

                // Remove first row (headers)
                worksheet.spliceRows(1, 1);

            }
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${FileName}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } else if (res[0].Status === 'ERROR') {
            NotificationSound(res[0].Status, res[0].Message, '');
        } else if (res[0].Status === 'UNAUTHORIZED') {
            NotificationSound(res[0].Status, res[0].Message, '');
        }

    } catch (err) {
        NotificationSound('ERROR', err.message);
    }
};

export const handleDownloadExcelForMultiObject = async (
    handleApiUrl,
    requestData,
    FileName,
    enableAlternateColor = false,
    enableHeaderColor = true,
    enableFilters = false
) => {
    const apiUrl = handleApiUrl;
    const requestBody = {
        ...requestData,
        authToken: pathName ? CommonApiData().UserAuthToken : CommonApiData().AuthToken,
        loginToken: CommonApiData().LoginToken,
        loginUserCode: CommonApiData().UserCode,
        Source: 'Web',
        Type: 'E',
        PageIndex: '1'
    };

    const requestHeaders = {
        'Content-Type': 'application/json',
    };

    try {
        const response = await fetch(`${virtualPath + apiUrl}`, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: requestHeaders,
        });

        const res = await response.json();

        if (res.Status === "SUCCESS") {
            if (res?.Data?.length > 0) {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet 1', {
                    views: [{ state: 'frozen', ySplit: 1 }],
                });

                // Define headers
                const headerRow = worksheet.addRow(
                    res?.HeadersKey?.length > 0
                        ? res.HeadersKey.filter((key) =>
                            res?.HideColumns?.length > 0 ? !res?.HideColumns.includes(key) : key
                        )
                        : Array.from(
                            new Set(
                                res?.Data?.flatMap((data) => Object.keys(data)).filter(
                                    (columnName) => !res?.HideColumns.includes(columnName)
                                )
                            )
                        )
                );

                const headerKey =
                    res?.HeadersKey?.length > 0 && res?.HeadersValue?.length > 0
                        ? res.HeadersValue.filter((key) =>
                            res?.HideColumns?.length > 0 ? !res?.HideColumns.includes(key) : key
                        )
                        : Array.from(
                            new Set(
                                res?.Data?.flatMap((data) => Object.keys(data)).filter(
                                    (columnName) => !res?.HideColumns.includes(columnName)
                                )
                            )
                        );

                headerRow.font = { bold: true };

                if (enableHeaderColor) {
                    headerRow.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'AAAAAA' },
                    };
                }

                if (enableFilters) {
                    worksheet.autoFilter = {
                        from: { row: 1, column: 1 },
                        to: { row: 1, column: headerKey.length },
                    };
                }

                for (let i = 2; i <= res?.Data?.length + 1; i++) {
                    const row = worksheet.getRow(i);

                    if (enableAlternateColor && i % 2 === 0) {
                        row.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'DDDDDD' },
                        };
                    }

                    // 🔄 Replace literal \r\n or actual line breaks with real newlines for Excel
                    row.values = (res?.HeadersValue?.length > 0
                        ? res.HeadersValue.map((key) => res.Data[i - 2][key])
                        : headerKey.map((key) => res.Data[i - 2][key])
                    ).map((cellValue) => {
                        if (typeof cellValue === 'string') {
                            return cellValue
                                .replace(/\\r\\n/g, '\n') // handles escaped \r\n
                                .replace(/\r\n/g, '\n');  // handles real carriage returns from backend
                        }
                        return cellValue;
                    });
                }

                // 🔁 Enable wrapText for all cells
                worksheet.eachRow({ includeEmpty: true }, (row) => {
                    row.eachCell((cell) => {
                        cell.alignment = { wrapText: true };
                    });
                });

                // 📏 Auto-fit columns
                worksheet.columns.forEach((column) => {
                    let maxLength = 0;
                    column.eachCell({ includeEmpty: true }, (cell) => {
                        const length = cell.value ? String(cell.value).length : 0;
                        maxLength = Math.max(maxLength, length);
                    });
                    column.width = maxLength < 12 ? 12 : maxLength;
                });

                // 💾 Generate and download file
                const buffer = await workbook.xlsx.writeBuffer();
                const data = new Blob([buffer], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${FileName}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                NotificationSound('ERROR', res.Message);
            }
        } else {
            NotificationSound(res.Status, res.Message, res.focus);
        }

        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus);
        }
    } catch (err) {
        NotificationSound('ERROR', err?.Message || 'Something went wrong');
    }
};
